import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { c as d } from "../clsx-OuTLNxxd.js";
import { A as g, a as h } from "../Avatar-DjiAoB1w.js";
import { B as f } from "../Button-DIvSLTPg.js";
import '../Profile.css';const r = "320px", _ = "600px", u = "1025px", z = "_profile_11ndu_32", H = "_image_11ndu_36", p = "_name_11ndu_44", b = "_description_11ndu_49", S = "_link_11ndu_50", W = "_details_11ndu_84", e = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: r,
  "mobile-wide": "480px",
  tablet: _,
  "tablet-wide": "800px",
  desktop: u,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  profile: z,
  image: H,
  name: p,
  description: b,
  link: S,
  "layout-column": "_layout-column_11ndu_77",
  "layout-row": "_layout-row_11ndu_81",
  details: W,
  "size-s": "_size-s_11ndu_91",
  "size-m": "_size-m_11ndu_96",
  "size-l": "_size-l_11ndu_107"
}, w = ({
  description: n,
  headingLevel: s = "h3",
  image: c,
  layout: a = "column",
  name: x,
  profileLink: i,
  size: m = "m",
  ...o
}) => {
  const y = s;
  return /* @__PURE__ */ l(
    "div",
    {
      "data-cxy-name": "profile",
      ...o,
      className: d(e.profile, e[`size-${m}`], e[`layout-${a}`], o.className),
      children: [
        /* @__PURE__ */ t(g, { className: e.image, children: /* @__PURE__ */ t(h, { alt: `Image of ${x}`, src: c }) }),
        /* @__PURE__ */ l("div", { className: e.details, children: [
          /* @__PURE__ */ t(y, { className: e.name, children: x }),
          n && /* @__PURE__ */ t("p", { className: e.description, dangerouslySetInnerHTML: { __html: n } }),
          i && /* @__PURE__ */ t(f, { asChild: !0, className: e.link, variant: "ghostBrand", children: /* @__PURE__ */ t("a", { href: i.href, children: i.text }) })
        ] })
      ]
    }
  );
};
export {
  w as Profile
};
